import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { ICheckboxSelectionData, SharedConstants, TextType } from '@app/eds';

export interface ITitleCheckboxOptions {
  id: number;
  name: string;
  checked?: boolean;
}

@Component({
  selector: 'app-title-checkbox-options',
  templateUrl: './title-checkbox-options.component.html',
  styleUrls: ['./title-checkbox-options.component.scss']
})
export class TitleCheckboxOptionsComponent implements OnInit {
  wareHouseForm!: FormGroup;

  // title/label for the title-checkbox component
  @Input() title: string = SharedConstants.EMPTY_STRING;

  // title/label for the title-checkbox component
  @Input() checkboxLabelFontType!: TextType;

  @Input() required = false;

  // event emitter to emit event when checkbox is clicked
  @Output() checkboxOptions: EventEmitter<string[]> = new EventEmitter();
  @Input() optionsList: ITitleCheckboxOptions[] = [];

  // string array to store all the checked checkboxes
  @Input() optionsChecked: string[] = [];

  // If true then all checkbox will be disabled.
  @Input() isDisabled = false;

  constructor(private readonly fb: FormBuilder) { }

  ngOnInit(): void {
    this.wareHouseForm = this.fb.group({
      warehouse_destination: this.fb.array([])
    });
    this.checkIfOptionsArePreSelected();
  }

  /**
   * Checks if all options are selected or not
   */
  checkIfOptionsArePreSelected() {
    this.optionsList.forEach((option: ITitleCheckboxOptions) => {
      const optionChecked: string[] = this.optionsChecked.filter(
        (selectedOption: string) => {
          return selectedOption === option.id.toString();
        }
      );
      if (optionChecked.length) {
        option.checked = true;
      }
    });
  }

  /**
   * Emits an event when checkbox is checked or unchecked.
   *
   * @param {ICheckboxSelectionData} event
   */
  clickCheckbox(event: ICheckboxSelectionData) {
    this.getSelectedOption(event);
    this.checkboxOptions.emit(this.optionsChecked);
  }

  /**
   * Add/removes the option from selected list
   *
   * @param {ICheckboxSelectionData} event
   */
  getSelectedOption(event: ICheckboxSelectionData) {
    if (event.isCheckedBool) {
      event.checkboxId && this.optionsChecked.push(event.checkboxId);
    } else {
      this.optionsChecked = this.optionsChecked.filter((item) => {
        return item !== event.checkboxId;
      });
    }
  }
}
